import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { faAward, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { useGetCrStudentResponseMutation } from '../../../../../../../features/authentication/reportApiSlice';
import { useSearchByQuestionIdMutation } from '../../../../../../../features/authentication/questionSearchApiSlice';
import CustomToast from '../../../../../../../components/Toast';
import CRStudentResponse from './CRStudentRespone';
import QuestionPreviewBasicModal from '../../../../../../questionsSearch/components/QuestionPreviewBasicModal';

const Table = ({
  title,
  subtitle,
  openedQuestions,
  setOpenedQuestions,
  questionStandards,
  questionResponses,
  studentCount,
  index,
  responseCount,
  isCrQuestion,
  questionId,
  questionType,
  courseId
}) => {
  const [openStudentResponseModel, setOpenStudentResponseModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [crStudentResponse, setCrStudentResponse] = useState([]);
  const [openQuestionDetailModel, setOpenQuestionDetailModel] = useState(false);
  const [isQuestionLoading, setIsQuestionLoading] = useState(false);
  const [questionDetails, setQuestionDetails] = useState(null);

  const [getCrStudentResponse] = useGetCrStudentResponseMutation();
  const [getQuestionDetails] = useSearchByQuestionIdMutation();

  const { Id } = useParams();

  const manageExpand = () => {
    let newQuestions = [...openedQuestions];
    if(openedQuestions.includes(questionId))
      newQuestions = newQuestions.filter(id=>id != questionId);
    else
      newQuestions.push(questionId);

    setOpenedQuestions(newQuestions);
  };

  const getStudentResponse = async () => {
    setOpenStudentResponseModel(true);
    setIsLoading(true);
    const option = {
      assignmentId: Id,
      questionId: questionId
    };
    const response = await getCrStudentResponse(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Error, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      setCrStudentResponse(response.data);
    }
    setIsLoading(false);
  };

  const getQuestionColor = () => {
    let response = null;

    if (questionResponses.length > 0) {
      if (!isCrQuestion)
        response = questionResponses.find((item) => item.isCorrect);
      else
        response = questionResponses[questionResponses.length - 1];
    }
    const percent = response == null ? 0 : Math.round((response.count / studentCount) * 100);
    return getColorCode(percent);

  };

  const getColorCode = (percent) => {
    if (percent <= 74)
      return 'bg-danger';
    else if (percent > 74 && percent <= 84)
      return 'bg-warning';
    else
      return 'bg-success';
  };

  const getQuestionDetailsAsync = async () => {
    setOpenQuestionDetailModel(true);
    setIsQuestionLoading(true);
    const option = {
      keyWord: questionId.toString(),
      pageNumber:1,
      pageSize:1,
      courseId:courseId,
      courseIds: [courseId]
    };
    const response = await getQuestionDetails(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Error, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      setQuestionDetails(response.data.questions[0]);
    }
    setIsQuestionLoading(false);
  };
  
  return (
    <div className="mt-5 line">
      <div className="d-flex justify-content-between">
        <div className="table_title mb-3">
          <div className="align-items-center d-flex gap-2">
            <div className={`colored-dot ${getQuestionColor()}`}></div>
            <div className="tbl-title">{title + ' '}</div>
            {isCrQuestion &&
                <FontAwesomeIcon icon={faAward} className='mx-1 text-orange cr-icon' />
            }
            {responseCount > 0 ?
              (<div className="tbl-subtitle">({subtitle})</div>):
              (<div className="tbl-subtitle">{`(Question Type : ${questionType})`}</div>)
            }
            <button className={`${!isCrQuestion && 'mx-5'} btn btn-castleWhite`} onClick={()=>getQuestionDetailsAsync()}>View Question</button>
            {isCrQuestion &&
                <div className='fw-normal ml-8 text-orange fs-6 cursor-pointer response-text' onClick={() => getStudentResponse()}>View Student Response</div>
            }
          </div>
        </div>
        {responseCount > 0 ? (
          <button
            id={index}
            style={{
              background: '#e1eeff',
              color: 'rgba(84, 113, 200, 0.6)',
              width: '30px',
              height: '30px',
              textAlign: 'center',
              border: 'none',
              marginLeft: '10px'
            }}
            className="rounded-circle"
            onClick={() => manageExpand()}>
            {openedQuestions.includes(questionId) ? (
              <FontAwesomeIcon icon={faChevronDown} />
            ) : (
              <FontAwesomeIcon icon={faChevronRight} />
            )}
          </button>
        ) : (
          <button
            id={index}
            style={{
              background: '#e1eeff',
              color: 'rgba(84, 113, 200, 0.6)',
              width: '30px',
              height: '30px',
              textAlign: 'center',
              border: 'none',
              marginLeft: '10px',
              cursor: 'default'
            }}
            className="rounded-circle">
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        )}
      </div>
      <>
        {questionResponses.length > 0 ? (
          <div  className={`tbl-details ${openedQuestions.includes(questionId) ? '' : 'd-none'}`}>
            <div className="row gap-5">
              <div className='col-md-5'>
                <table className="table reportTable answer_report_tbl">
                  <thead>
                    <tr className="table-head">
                      <th>{isCrQuestion ? 'Points' : 'Response'}</th>
                      <th>Count</th>
                      <th>Percent</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                {questionResponses?.map((questionResponse) => {
                  return (
                    <>
                      <tr className="table-body">
                        <td>
                          {questionResponse?.answerText != null ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip className="custom-tooltip">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: questionResponse?.answerText
                                    }}></div>
                                </Tooltip>
                              }>
                              {questionResponse?.isCorrect === true ? (
                                <p className="correct-answer">
                                  {questionResponse.response + ' (Correct)'}
                                </p>
                              ) : (
                                <p>{questionResponse.response}</p>
                              )}
                            </OverlayTrigger>
                          ) : (
                            <p>{questionResponse.response}</p>
                          )}
                        </td>
                        <td>{questionResponse.count}</td>
                        <td>{Math.round((questionResponse.count / studentCount) * 100)}</td>
                        <td>
                          <CircularProgressbar
                            value={Math.round((questionResponse.count / studentCount) * 100)}
                            text={`${Math.round((questionResponse.count / studentCount) * 100)}%`}
                            strokeWidth={12}
                            styles={buildStyles({
                              pathColor: (Math.round((questionResponse.count / studentCount) * 100) <= 50 ?  '#FB5F5F' : '#52C9A5'),
                              textColor: '#525252',
                              trailColor: '#d6d6d6'
                            })}
                          />
                        </td>
                      </tr>
                    </>
                  );
                })}
                  </tbody>
                </table>
              </div>
              <div className="col-md-6">
                <div className='question_standard_info'>
                  {questionStandards.length > 0 &&
                    <>
                      <b>Question Standards</b>
                      {questionStandards.map((questionStandard) => (
                        <div key={questionStandard.id}>
                          <p>{questionStandard.standardName}</p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: questionStandard.standardDescription
                            }}></div>
                        </div>
                      ))}
                    </>}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </>
      {openStudentResponseModel &&
        <CRStudentResponse
          isOpen={openStudentResponseModel}
          onClose={setOpenStudentResponseModel}
          studentResponse={crStudentResponse}
          isLoading={isLoading}
        />
      }
      {openQuestionDetailModel &&
        <QuestionPreviewBasicModal
          isOpen={openQuestionDetailModel}
          onClose={setOpenQuestionDetailModel}
          details={questionDetails}
          isLoading={isQuestionLoading}
          fromQuestionSearch={false}
        />
      }
    </div>
  );
};

Table.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  questionText: PropTypes.string,
  openedQuestions: PropTypes.array,
  setOpenedQuestions: PropTypes.func,
  questionStandards: PropTypes.array,
  questionResponses: PropTypes.array,
  studentCount: PropTypes.number,
  index: PropTypes.number,
  isPrint: PropTypes.bool,
  responseCount: PropTypes.number,
  isCrQuestion: PropTypes.bool,
  questionId: PropTypes.number,
  questionType: PropTypes.string,
  courseId:PropTypes.number
};
export default Table;
